export const CONTRACTOR_LOAD = 'CONTRACTOR_LOAD';
export const UPDATE = 'UPDATE';
export const CLEAR = 'CLEAR';
export const SET_CONTRACTOR_PAGES = 'SET_CONTRACTOR_PAGES';
export const SET_SELECTED_PAGE = 'SET_SELECTED_PAGE';
export const SET_W9 = 'SET_W9';
